import axios from "axios";
import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { baseUrl } from "../utils/env";
import { useDispatch, useSelector } from "react-redux";
import { addGallery } from "../redux/actions/galleryAction";
import { GALLERY_ADD_RESET } from "../redux/constants/galleryConstant";
import { useNavigate } from "react-router-dom";

const AddGalleryScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const galleryAdd = useSelector((state) => state.galleryAdd);
  const { adminInfo } = useSelector((state) => state.adminLogin);
  const { success } = galleryAdd;
  const [title, setTitle] = useState("");
  const [image, setImage] = useState([]);
  const [previewSource, setPreviewSource] = useState([]);

  useEffect(() => {
    if (success) {
      navigate("/gallery");
      dispatch({ type: GALLERY_ADD_RESET });
    }
  }, [success]);
  const handleSubmitGalleryForm = (e) => {
    e.preventDefault();
    dispatch(addGallery(title, JSON.stringify(image)));
  };

  const previewFile = (file) => {
    console.log("file", file);

    // const reader = new FileReader();
    // if (file) {
    //   reader.readAsDataURL(file);
    // }
    // reader.onloadend = () => {
    //   setPreviewSource(reader.result);
    // };
  };
  const uploadFileHandler = async (e) => {
    const file = e.target.files;
    const formData = new FormData();
    previewFile(file);
    file.forEach(async (value) => {
      formData.append("image", value);
    });
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };

      const { data } = await axios.post(`${baseUrl}/upload`, formData, config);

      setImage(data);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Layout>
      <PageTitle title="Add New Gallery" />
      <div className="card">
        <div className="card-body">
          <form
            onSubmit={handleSubmitGalleryForm}
            encType="multipart/form-data"
          >
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                Title For Gallery
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Title For Gallery"
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>

            <div className="row mb-3">
              <label
                htmlFor="example-search-input"
                className="col-sm-2 col-form-label"
              >
                Choose Images
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="file"
                  multiple
                  onChange={uploadFileHandler}
                />
                {/* {previewSource && (
                  <div className="previewImage">
                    <img src={previewSource} alt="profile" />
                  </div>
                )} */}
              </div>
            </div>
            <button type="submit" className="btn btn-primary">
              Add New Gallery
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AddGalleryScreen;
